import axios from 'axios';
import {
  COLLECTIONS_LOAD_PROJECT_COLLECTIONS_BEGIN,
  COLLECTIONS_LOAD_PROJECT_COLLECTIONS_SUCCESS,
  COLLECTIONS_LOAD_PROJECT_COLLECTIONS_FAILURE,
  COLLECTIONS_LOAD_PROJECT_COLLECTIONS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadProjectCollections(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_LOAD_PROJECT_COLLECTIONS_BEGIN,
    });

    const { projectId, searchTerm, page, limit, collectionType, version, externalDatabaseId } =
      args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${
        process.env.REACT_APP_BUILDER_ENGINE
      }v${version}/collections/${projectId}/project${
        searchTerm ? `/search?searchTerm=${searchTerm}&` : '?'
      }`;
      if (page || page === 0) {
        url += `limit=${limit}&page=${page}`;
      }
      if (collectionType) {
        url += `&collectionType=${collectionType}`;
      }
      if (externalDatabaseId) {
        // Check if externalDatabaseId exists
        url += `${
          searchTerm || page || page === 0 || collectionType ? '&' : '?'
        }externalDatabaseId=${externalDatabaseId}`; // Append externalDatabaseId if it exists
      }
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_LOAD_PROJECT_COLLECTIONS_SUCCESS,
            data: res.data,
            pageNumber: page,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_LOAD_PROJECT_COLLECTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectCollectionsError() {
  return {
    type: COLLECTIONS_LOAD_PROJECT_COLLECTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_LOAD_PROJECT_COLLECTIONS_BEGIN:
      return {
        ...state,
        loadProjectCollectionsPending: true,
        loadProjectCollectionsError: null,
      };

    case COLLECTIONS_LOAD_PROJECT_COLLECTIONS_SUCCESS:
      return {
        ...state,
        loadProjectCollectionsPending: false,
        loadProjectCollectionsError: null,
        projectCollections: action.data.result ? action.data.result : action.data,
        totalCollectionPages: action.data.totalPages
          ? action.data.totalPages
          : state.totalCollectionPages,
        currentCollectionListPage:
          action.pageNumber || action.pageNumber === 0
            ? action.pageNumber
            : state.currentCollectionListPage,
      };

    case COLLECTIONS_LOAD_PROJECT_COLLECTIONS_FAILURE:
      return {
        ...state,
        loadProjectCollectionsPending: false,
        loadProjectCollectionsError: action.data.error,
      };

    case COLLECTIONS_LOAD_PROJECT_COLLECTIONS_DISMISS_ERROR:
      return {
        ...state,
        loadProjectCollectionsError: action.data,
      };

    default:
      return state;
  }
}
